import { Icon } from '@/components/icon';
import { Section } from '@/components/section';
import { reviews } from '@/data/reviews';

export function ReviewsSection(): React.ReactNode {
  return (
    <Section background="paper">
      <div className="mb-10 max-w-2xl">
        <h2 className="mb-3 text-3xl font-semibold sm:text-4xl">Kundenstimmen</h2>
        <p className="text-mute">
          Was unsere Kundinnen und Kunden über uns sagen. Wir verlinken auf Wunsch das Google-Profil
          mit weiteren Bewertungen.
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {reviews.map((review) => (
          <article key={review.id} className="rounded-lg border border-stone bg-bone p-6">
            <div
              className="mb-3 flex items-center gap-1 text-loam"
              aria-label={`${String(review.rating)} von 5 Sternen`}
            >
              {Array.from({ length: review.rating }, (_, idx) => (
                <Icon key={idx} name="Star" className="h-4 w-4 fill-current" />
              ))}
            </div>
            <p className="mb-4 text-bark">„{review.quote}“</p>
            <p className="text-sm font-semibold">{review.name}</p>
            <p className="text-sm text-mute">{review.city}</p>
          </article>
        ))}
      </div>
    </Section>
  );
}
